import { render } from "./New.vue?vue&type=template&id=4e6c2c50&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4e6c2c50"

export default script